import Hint from "@common/controls/Hint/component";
import { Common } from "@common/types";
import classNames from "classnames";
import * as React from "react";

type SelectOptionDescriptionProps = {
  descriptions: Common.OptionItemDescription[];
  isSingleLine?: boolean;
};
export const SelectOptionDescription = (props: SelectOptionDescriptionProps) => (
  <>
    {props.descriptions.map((x, i) => (
      <div key={i} className="info" title={props.isSingleLine ? x.label : undefined}>
        {x.isHint ? (
          <Hint hint={x.label} isSingleLine={props.isSingleLine} />
        ) : (
          <span
            className={classNames("content", {
              "single-line-ellipsis": props.isSingleLine
            })}
          >
            {x.label}
          </span>
        )}
      </div>
    ))}
  </>
);
